import React from 'react';
import useTheme from 'branding/theme';
import withHover from '../../hocs/withHover';
import AccessiblyHiddenChoice from '../AccessiblyHiddenChoice';
import withFocus from '../../hocs/withFocus';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
import useComponentMargin from '../../hooks/useComponentMargin';
export const RadioPill = React.forwardRef(({ labelText, name, value, disabled = false, checkedValue, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleBlur, handleFocus, onBlur, onChange, className, styles }, ref) => {
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const isSelected = value === checkedValue;
    const { colors, borders, inputs: { base, shape, size: inputSize, disabled: disabledInputStyles } } = useTheme();
    const marginStyles = useComponentMargin({
        margin: 'small'
    });
    const mergedStyles = {
        ...base,
        ...shape.pill,
        ...inputSize.regular,
        ...borders.variant.secondary,
        backgroundColor: colors.neutrals.background,
        ...(disabled && disabledInputStyles),
        ...(isHovered && {
            borderColor: colors.neutrals.textAlpha
        }),
        ...(isFocused && {
            backgroundColor: colors.brand.primary.gamma,
            borderColor: colors.brand.primary.beta
        }),
        ...(isSelected && {
            backgroundColor: colors.brand.primary.gamma,
            borderColor: colors.brand.primary.alpha
        }),
        ...(isHovered &&
            isSelected && {
            backgroundColor: colors.brand.primary.beta,
            borderColor: colors.brand.primary.alpha
        }),
        ...marginStyles,
        position: 'relative',
        display: 'inline-block',
        ...styles
    };
    return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("div", { className: className, style: mergedStyles, 
        // putting `tabIndex` here would hinder accessibility
        onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: focusHandlers.onFocus, onBlur: focusHandlers.onBlur, role: "listbox" },
        React.createElement(AccessiblyHiddenChoice, { type: "radio", name: name, disabled: disabled, isHovered: isHovered, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, value: value, onChange: onChange, handleBlur: handleBlur, ref: ref, ...focusHandlers }),
        React.createElement("label", { htmlFor: name }, labelText)));
});
export default withHover(withFocus(withFormProps(RadioPill)));
//# sourceMappingURL=index.js.map